// extracted by mini-css-extract-plugin
module.exports = {"container":"textFilter_container__1V_Ri","text":"textFilter_text__26wCg","filter":"textFilter_filter__3TsEu"};